import { AxiosInstance } from 'axios'
import { SALES_ENDPOINTS } from 'api/ApiRoutes'

class SalesApi {
  constructor(private axiosInstance: AxiosInstance) {}

  cleanData = async () => {
    const d = await this.axiosInstance.delete<
      | {
          result: 'success'
          job_token_id: string
        }
      | {
          result: 'error'
          message: string
        }
    >(SALES_ENDPOINTS.DATA_CLEANING)
    return d.data
  }
}

export default SalesApi
